export * from './data-autocomplete-templates.component';
